import "./MatchInfo.css";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

import { ISoccerMatch } from "../../../../../../types";

export const MatchInfo = ({
  soccerMatch,
}: {
  soccerMatch: ISoccerMatch;
}) => {
  const dtPrematch = dayjs(soccerMatch.matchDateTime).format("D MMMM YYYY");

  const currentVenue = soccerMatch.venue;
  const venueName = currentVenue?.longName || currentVenue?.name || currentVenue?.shortName;
  const venueCity = currentVenue?.city;

  return (
    <div className="match-info match-info--prematch">
      {!!venueName && (
        <div className="match-info-prematch-item">
          <img src="/images/box-score/pin.svg" alt="location" width={12} height={14} />
          <span>{venueName}{venueCity ? `, ${venueCity}` : ""}</span>
        </div>
      )}
      <div className="match-info-prematch-item">
        <img src="/images/box-score/calendar-dates.svg" alt="date" width={13} height={13} />
        <span>{dtPrematch}</span>
      </div>
    </div>
  );
};
